const isSid = (sid) => new RegExp(/^sid_[a-zA-Z0-9]{26}$/).test(sid);

export default isSid;
